export const POST_ORDER_START = 'POST_ORDER_START';
export const POST_ORDER_SUCCESS = 'POST_ORDER_SUCCESS';
export const POST_ORDER_FAIL = 'POST_ORDER_FAIL';
export const GET_ORDERS_START = 'GET_ORDERS_START';
export const GET_ORDERS_SUCCESS = 'GET_ORDERS_SUCCESS';

export const CANCEL_ORDER_START = 'CANCEL_ORDER_START';
export const CANCEL_ORDER_SUCCESS = 'CANCEL_ORDER_SUCCESS';
export const CANCEL_ORDER_FAIL = 'CANCEL_ORDER_FAIL';

// Order parameters
export const UPDATE_ORDER_PARAMS = 'UPDATE_ORDER_PARAMS';
export const REFETCH_ORDERS = 'REFETCH_ORDERS';
export const UPDATE_ORDER_VIA_SOCKET = 'UPDATE_ORDER_VIA_SOCKET';